import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import GreenButton from "../../common/button/greenButton";
import { cssProperties } from "../../utils/commonCssProperties";
import CommonTable from "./../../common/CommonTable";
import CloseButton from "../../common/button/closeButton";
import DangerButton from "../../common/button/DangerButton";
import BrowseUploadButton from "../../common/button/browseUploadButton";
import axios from "axios";
import { API_URL, NODE_ENV } from "../../utils/constants";
import { IoCloudUploadOutline } from "react-icons/io5";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import MauvelousPrimaryButton from "./../../common/button/mauvelousPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import venueActions from "../../redux/venue/actions";
import { useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import xlsx from "json-as-xlsx";
import commonActions from "../../redux/common/actions";

import { percentageValidation } from "../../utils/validation";
import { useForm } from "react-hook-form";
import DuplicateCandidates from "./DuplicateCandidates";

// let data = [
//   {
//     name: "Candidates",
//     value: "1256",
//   },
//   {
//     name: "Venues",
//     value: "324",
//   },
//   {
//     name: "Venue Capacity for batch",
//     value: "324",
//   },
// ];
// let data2 = [
//   {
//     name: "Non Allocated Candidates",
//     value: "1256",
//   },
//   {
//     name: "Diability Candidates",
//     value: "324",
//   },
// ];
// let tableData = [
//   {
//     course_name: "course_1",
//     candidate_count: 10245,
//     exam_date: "23/05/2024",
//     batch_no: 1,
//     first_preference: "-----",
//     second_preference: "-----",
//     third_preference: "-----",
//   },
//   {
//     course_name: "course_2",
//     candidate_count: 10245,
//     exam_date: "23/05/2024",
//     batch_no: 1,
//     first_preference: "-----",
//     second_preference: "-----",
//     third_preference: "-----",
//   },
// ];

let data = [
  {
    sheet: "Venue Master Template",
    columns: [
      { label: "Venue Id", value: "Venue Id" },
      { label: "Batch", value: "Batch" },
      { label: "From Date", value: "From Date" },
      { label: "To Date", value: "To Date" },
      { label: "Seats Availability", value: "Seats Availability" },
      { label: "Buffer Seats", value: "Buffer Seats" },
      { label: "Venue Name", value: "Venue Name" },
      { label: "Venue Type", value: "Venue Type" },
      { label: "Pincode", value: "Pincode" },
      { label: "Address Line 1", value: "Address Line 1" },
      { label: "Address Line 2", value: "Address Line 2" },
      { label: "Landmark", value: "Landmark" },
      { label: "Village", value: "Village" },
      { label: "City", value: "City" },
      { label: "Taluka", value: "Taluka" },
      { label: "District", value: "District" },
      { label: "State", value: "State" },
      { label: "Google Map Link", value: "Google Map Link" },
      { label: "Building Type", value: "Building Type" },
      { label: "Suitable For Pwd", value: "Suitable For Pwd" },
      { label: "latitude" , value: "latitude"},
      { label: "longitude", value: "longitude"}

      // { label: "addressline2" },
    ],
    content: [
      {
        "Venue Id": "V70",
        "Batch": 1,
        "From Date": "2024-05-23",
        "To Date": "2024-05-23",
        "Seats Availability": 20,
        "Buffer Seats": 2,
        "Venue Name": "GALAXY INFORMATION TECHNOLOGY",
        "Venue Type": "Institute",
        Pincode: 442605,
        "Address Line 1":
          "CAMP AREA NEAR DURGA MATA TEMPLE DHANORA ROAD GADCHIROLI",
        Landmark: "DURGA MATA TEMPLE",
        Village: "Gadchiroli",
        City: "GADCHIROLI",
        Taluka: "Gadchiroli",
        District: "Gadchiroli",
        State: "Maharashtra",
        "Google Map Link": "",
        "Building Type": "Educational",
        "Suitable For Pwd": true,
        latitude :"19.18576532",	
        longitude: "72.82982861"
      },
    ],
  },
];

let settings = {
  fileName: "venue template",
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
  RTL: false,
};

let callback = function (sheet) {};
let columnData = [
  {
    name: "Course Name",
    dataIndex: "coursename",
  },
  {
    name: "Candidate Count",
    dataIndex: "candidatecount",
  },
  {
    name: "Exam Date",
    dataIndex: "examdate",
  },
  {
    name: "Batch No",
    dataIndex: "batchno",
  },
  {
    name: "Allocated based on 1st preference",
    dataIndex: "preference1",
  },
  {
    name: "Allocated based on 2nd preference",
    dataIndex: "preference2",
  },
  {
    name: "Allocated based on 3rd preference",
    dataIndex: "preference3",
  },
  {
    name: "Allocated based on 4th preference",
    dataIndex: "preference4",
  },
  {
    name: "Manually Allocated Candidates",
    dataIndex: "preference5",
  },
];

const Index = () => {
  const socketRef = useRef(null);

  // const socket = io(`http://localhost:3001`);

  const [file, setFile] = useState(null);
  const [courseid, setCourseId] = useState(0);
  const [pcmb, setPcmb] = useState(0);
  const [open, setOpen] = useState(false);
  const [importApiConfirmOpen, setImportApiConfirmOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null); // { kind: "run" | "reset", impact, action }
  const [intervalId, setIntervalId] = useState(null);
  const [ispcm , setIspcm] = useState(0);
  const [ispcb , setIspcb] = useState(0);
  const [noofattempt , setNoofAttempt] = useState(0); 

  const {
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({ mode: "all" });
  let formValues = watch();
  useEffect(() => {
    for (let key in formValues) {
      // setValue(key, formValues[key])
      // trigger(key)
    }
    // trigger()
  }, [formValues, setValue]);

  let male = parseFloat(watch("male")) || 0;
  let others = parseFloat(watch("others")) || 0;
  let general = parseFloat(watch("general")) || 0;
  let female = parseFloat(watch("female")) || 0;
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const [loading, setLoading] = useState(false);
  const [preferenceid, setPreferenceId] = useState(0);
  const [isLogicApplied, setIsLogicApplied] = useState("0");
  const [logic, setLogic] = useState(1);
  const id = useLocation()?.state?.id;

  const dispatch = useDispatch();
  const { courseList } = useSelector((state) => state.masterReducer);
  const {
    candidateCount,
    venueDetails,
    seatAllocationData,
    candidateAllocationDetails,
    categoriesOfCourse,
    allocationStatus
  } = useSelector((state) => state.venueReducer);

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  // The four card lists combined, for the "All Candidates" download.
  const allCandidates = useMemo(
    () => [
      ...(candidateAllocationDetails?.allocated || []),
      ...(candidateAllocationDetails?.notallocated || []),
      ...(candidateAllocationDetails?.disabilityallocated || []),
      ...(candidateAllocationDetails?.disabilitynotallocated || []),
    ],
    [candidateAllocationDetails]
  );
  const categories = useMemo(() => {
    let data = [];
    categoriesOfCourse?.forEach((item) => {
      data.push({
        label: item.category,
        value: item.categoryid,
        id: `cat_${item.categoryid}`,
      });
    });
    return data;
  }, [categoriesOfCourse]);
  let getDataInterval = (courseid, currentVenueId) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("listenstatus", { courseid, currentVenueId });
    }, 900000);
    return intervalId;
  };
  // useEffect(() => {
  //   socketRef.current = io(
  //     `${API_URL}`,
  //     NODE_ENV === "production" && {
  //       path: "/api/socket.io",
  //       //     transports: ['websocket', 'polling'],
  //       // reconnection: true,
  //       // reconnectionAttempts: 5,
  //       // reconnectionDelay: 1000
  //     }
  //   );
  //   return () => (socketRef.current = null);
  // }, []);
  // useEffect(() => {
  //   socketRef?.current?.on("listenmessage", (message) => {
  //     // let data = message?.data
  //     if (message?.statusCode === 200) {
  //       let statustext = message?.data?.trim();
  //       if (statustext) {
  //         if (statustext?.toLowerCase() !== "completed") {
  //           setStatusModalOpen({
  //             open: true,
  //             statustext:
  //               statustext?.trim() !== "" && statustext !== null
  //                 ? statustext
  //                 : statusModalopen.statustext,
  //           });
  //         } else {
  //           setStatusModalOpen({
  //             open: false,
  //             statustext:
  //               statustext?.toLowerCase() !== "completed"
  //                 ? ""
  //                 : statusModalopen.statustext,
  //           });

  //           dispatch({
  //             type: venueActions.GET_SEAT_ALLOCATION,
  //             payload: { courseid },
  //           });
  //           dispatch({
  //             type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
  //             payload: { courseid },
  //           });
  //           clearInterval(intervalId);
  //           dispatch({
  //             type: commonActions.SET_ALERT,
  //             payload: {
  //               status: "success",
  //               show: true,
  //               message: "seat allocated successfully",
  //             },
  //           });

  //           setTimeout(function () {
  //             dispatch({
  //               type: commonActions.SET_ALERT,
  //               payload: {
  //                 status: "success",
  //                 show: false,
  //                 message: null,
  //               },
  //             });
  //           }, 2000);
  //         }
  //       }
  //       //  else {
  //       //   setStatusModalOpen({
  //       //     open: false,
  //       //     statustext: "",
  //       //   });
  //       // }
  //     }
  //   });
  //   return () => socketRef?.current?.off("listenmessage");
  // }, [courseid, dispatch, intervalId, socketRef]);
  useEffect(() => {
    // id ? setCourseId(id) : setCourseId(0);
    if (id) {
      const idPayload = { courseid: id, ispcm, ispcb, noofattempt };
      dispatch({ type: venueActions.GET_VENUE_DETAILS, payload: { ...idPayload } });
      dispatch({ type: venueActions.GET_CANDIDATE_COUNT, payload: { ...idPayload } });
      dispatch({ type: venueActions.GET_SEAT_ALLOCATION, payload: { ...idPayload } });
      dispatch({ type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS, payload: { ...idPayload } });
    }
  }, [id, dispatch]);
  // useEffect(() => {
  //   if (courseid > 0) {
  //     dispatch({
  //       type: venueActions.GET_VENUE_DETAILS,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_CANDIDATE_COUNT,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_SEAT_ALLOCATION,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
  //       payload: { courseid },
  //     });
  //   }
  // }, [courseid, dispatch]);
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: venueActions.GET_SEAT_ALLOCATION_DETAILS });
    return () => {
      dispatch({
        type: venueActions.GET_CANDIDATE_COUNT,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_VENUE_DETAILS,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_SEAT_ALLOCATION,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
        payload: [],
      });
    };
  }, [dispatch]);
  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const commonPayload = { courseid, ispcm, ispcb, noofattempt };
        courseid && dispatch({
          type: venueActions.GET_ALLOCATION_STATUS,
          payload: { ...commonPayload },
        });
        courseid && dispatch({
          type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
          payload: { ...commonPayload },
        });
      } catch (err) {
        console.error(err);
      }
    };
    fetchProgress();
    const interval = setInterval(fetchProgress, 10000);
    return () => clearInterval(interval);
  }, [courseid, ispcm, ispcb, noofattempt, dispatch]);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setFile(file);
  };
  const handleUploadVenue = async () => {
    dispatch({
      type: venueActions.UPLOAD_VENUE_DATA,
      payload: { courseid, file, setOpen, setLoading, ispcm, ispcb, noofattempt },
    });
  };
  // Buffer seats per venue and batch: total, used by venue changes, left.
  const downloadBufferSeatReport = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/backoffice/venuedata/buffer-seat-report/${courseid}`,
        { params: { ispcm, ispcb, noofattempt } }
      );
      const rows = response?.data?.data || [];
      if (rows.length === 0) {
        showAlert("failed", "No venue of this course has buffer seats");
        return;
      }
      const columns = Object.keys(rows[0]).map((key) => ({ label: key, value: key }));
      xlsx(
        [{ sheet: "Buffer Seats", columns, content: rows }],
        { ...settings, fileName: "Buffer Seat Report" },
        callback
      );
    } catch (err) {
      showAlert("failed", err?.response?.data?.message || "Failed to download the buffer seat report");
    }
  };
  const showAlert = (status, message) => {
    dispatch({ type: commonActions.SET_ALERT, payload: { status, show: true, message } });
    setTimeout(
      () => dispatch({ type: commonActions.SET_ALERT, payload: { status: null, show: false, message: null } }),
      2000
    );
  };
  const ToggleOpen = () => {
    setOpen(!open);
  };
  const handleImportVenueFromApi = () => {
    setImportApiConfirmOpen(false);
    dispatch({
      type: venueActions.IMPORT_VENUE_DATA_API,
      payload: { courseid, ispcm, ispcb, noofattempt },
    });
  };
  const onChangeCourse = async (e) => {
    setCourseId(e.target.value);
    setPcmb(0);
    setIspcm(0);
    setIspcb(0);
    setNoofAttempt(0);
  };

  const onSelectCourse = () => {
    if (courseid) {
      const commonPayload = {
        courseid,
        ispcm,
        ispcb,
        noofattempt,
      };
      dispatch({
        type: venueActions.GET_CANDIDATE_COUNT,
        payload: { ...commonPayload },
      });
      dispatch({
        type: venueActions.GET_VENUE_DETAILS,
        payload: { ...commonPayload },
      });
      dispatch({
        type: venueActions.GET_SEAT_ALLOCATION,
        payload: { ...commonPayload },
      });
      dispatch({
        type: venueActions.GET_CATEGORIES_OF_COURSE,
        payload: { ...commonPayload },
      });
      dispatch({
        type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
        payload: { ...commonPayload },
      });
    }
    return;
  };
  const onError = () => {};
  const onRunPreference = async (data) => {
    // let gender = {
    //   male: data["male"],
    //   female: data["female"],
    //   others: data["others"],
    // };
    let gender = {
        male: parseFloat(data["male"]) || 0,
        female: parseFloat(data["female"]) || 0,
        others: parseFloat(data["others"]) || 0,
      };

    let categoriesArray = [];
    categories.forEach((cat) => {
      // categoriesArray.push({ categoryid: cat.value, value: data[cat.id] });
      categoriesArray.push({ categoryid: cat.value, value: parseFloat(data[cat.id]) || 0 });
    });
    // let others = {
    //   orphan: data["orphan"],
    //   pwd: data["pwd"],
    //   categories: categoriesArray,
    // };
     let others = {
        orphan: parseFloat(data["orphan"]) || 0,
        pwd: parseFloat(data["pwd"]) || 0,
        categories: categoriesArray,
      };
    if (
      courseid
      // && (courseList?.all?.find(obj=>obj.courseid == courseid)?.ispcmb ? pcmb : 1)
    ) {
      const runAction = {
        type: venueActions.RUN_SEAT_ALLOCATION,
        payload: {
          courseid: courseid,
          preferenceid: preferenceid,
          adminuserid: backofficeTokenDetails?.id,
          isLogicApplied: isLogicApplied,
          // getDataInterval: getDataInterval,
          setIntervalId: setIntervalId,
          pcmb: pcmb,
          ispcmb: courseList?.all?.find((obj) => obj.courseid == courseid)
            ?.ispcmb,
          setStatusModalOpen: setStatusModalOpen,
          gender,
          others,
          ispcm : ispcm,
          ispcb : ispcb,
          attempt : noofattempt
          //   getDataInterval: () =>
          //     socketRef?.current?.emit("listenstatus", { courseid }),
        },
      };
      confirmIfAllocated("run", runAction);
    }
  };
  const handlePreferenceChange = (e) => {
    setPreferenceId(e.target.value);
  };

  // Run and Reset both delete the selected run's allocations, roll numbers and
  // venue changes, so ask first when there is anything to delete.
  const confirmIfAllocated = async (kind, action) => {
    try {
      const response = await axios.get(
        `${API_URL}/backoffice/venuedata/allocation-impact/${courseid}`,
        { params: { ispcm, ispcb, noofattempt } }
      );
      const impact = response?.data?.data;
      if (impact?.allocations > 0) {
        setDeleteConfirm({ kind, impact, action });
        return;
      }
    } catch (err) {
      // The check is a safeguard only; Run and Reset report their own errors.
    }
    dispatch(action);
  };

  const onReset = (courseid, preferenceid = 0) => {
    courseid &&
      confirmIfAllocated("reset", {
        type: venueActions.RESET_SEAT_ALLOCATION,
        payload: {
          courseid,
          preferenceid,
          userid: backofficeTokenDetails?.id,
          ispcm,
          ispcb,
          attempt: noofattempt,
        },
      });
  };
  const onChangePCMB = (e) => {
    setPcmb(e.target.value);
    if (e.target.value == 1) {
      setIspcm(1);
      setIspcb(0);
    } else if (e.target.value == 2) {
      setIspcm(0);
      setIspcb(1);
    } else {
      setIspcm(0);
      setIspcb(0);
    }
  };
  const handleLogicAppliedChange = (e) => {
    setIsLogicApplied(e.target.value);
    setValue("male", 0);
    setValue("female", 0);
    setValue("others", 0);
    setValue("pwd", 0);
    setValue("orphan", 0);
    categories.forEach((cat) => {
      setValue(cat.id, 0);
    });
  };
  const handleLogicChange = (e) => {
    setLogic(e.target.value);
    setValue("male", 0);
    setValue("female", 0);
    setValue("others", 0);
  };
  return (
    <>
      <Card
        sx={{
          width: "100%",
          textAlign: "start",
          borderRadius: "8px",
          // cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "none",
          padding: 2,
          background: "none",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="p"
            color="#212121"
            fontWeight={600}
            sx={{ paddingBottom: 2 }}
            component="p"
          >
            Get Allocated Data
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item md={4}>
            <Box>
              <Select
                size="small"
                onChange={onChangeCourse}
                value={courseid}
                defaultValue={0}
                sx={{ width: "100%", minWidth: "200px" }}
              >
                <MenuItem value={0} selected>
                  Courses
                </MenuItem>
                {courseList?.all
                ?.filter(course => ![153, 155].includes(course.courseid))
                .map((course, i) => (
                  <MenuItem key={i} value={course.courseid}>
                    {course.coursename}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          {courseList?.all?.find((obj) => obj.courseid == courseid)
              ?.ispcmb && <Grid item md={2}>
            {courseList?.all?.find((obj) => obj.courseid == courseid)
              ?.ispcmb && (
              <Box>
                <Select
                  size="small"
                  onChange={onChangePCMB}
                  value={pcmb}
                  defaultValue={0}
                  sx={{ width: "100%" }}
                >
                  <MenuItem value={0} selected>
                    Select Subject Group
                  </MenuItem>
                  <MenuItem value={1}>PCM</MenuItem>
                  <MenuItem key={2} value={2}>
                    PCB
                  </MenuItem>
                </Select>
              </Box>
            )}
          </Grid>}
          {courseList?.all?.find((obj) => obj.courseid == courseid && [125, 124].includes(courseid)) && <Grid item md={3}>
            {courseList?.all?.find((obj) => obj.courseid == courseid && [125, 124].includes(courseid))
               && (
              <Box>
                <Select
                  size="small"
                  onChange={(e)=>setNoofAttempt(e.target.value)}
                  value={noofattempt}
                  defaultValue={0}
                  sx={{ width: "100%" }}
                >
                  <MenuItem value={0} selected>
                    Select Attempt
                  </MenuItem>
                  <MenuItem value={1}>Attempt 1</MenuItem>
                  <MenuItem key={2} value={2}>Attempt 2</MenuItem>
                </Select>
              </Box>
            )}
          </Grid>}

          <Grid item md={2}>
            <BluePrimaryButton
              title="Select"
              handleSubmit={onSelectCourse}
              disabled={
                !courseid ||
                (!!courseList?.all?.find((obj) => obj.courseid == courseid)?.ispcmb && !pcmb) ||
                ([124, 125].includes(courseid) && !noofattempt)
              }
            />
          </Grid>
          {/* <div>Allocation Status : {allocationStatus.length > 0 && allocationStatus[0]?.status} Allocated Candidates : {allocationStatus.length > 0 && allocationStatus[0]?.allocated_candidates}</div> */}
          <Box
  sx={{
    p: 2,
    borderRadius: 2,
    bgcolor: "#f5f5f5",
    display: "flex",
    gap: 2,
    alignItems: "center",
  }}
>
  {/* <Typography variant="subtitle1" fontWeight={600}>
    Allocation Status:
  </Typography>

  <Typography
    variant="body1"
    sx={{ color: "primary.main", fontWeight: 500 }}
  >
    {(courseid ? allocationStatus?.[0]?.status : "N/A") || "N/A"}
  </Typography> */}

  {/* <Typography variant="subtitle1" fontWeight={600}>
    Allocated Candidates:
  </Typography> */}

  {/* <Typography
    variant="body1"
    sx={{ color: "success.main", fontWeight: 500 }}
  >
    {(courseid ? allocationStatus?.[0]?.allocated_candidates : "N/A") || 0}
  </Typography> */}
</Box>
          <Grid item md={12}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <BluePrimaryButton
                title="Get Venue data(API)"
                handleSubmit={() => setImportApiConfirmOpen(true)}
                disabled={
                  !courseid ||
                  (!!courseList?.all?.find((obj) => obj.courseid == courseid)?.ispcmb && !pcmb) ||
                  ([124, 125].includes(courseid) && !noofattempt)
                }
              />
              <BluePrimaryButton
                handleSubmit={ToggleOpen}
                title="Browse and Upload Venue data"
              />
              <GreenButton
                handleSubmit={() => xlsx(data, settings, callback)}
                title="Download Template"
              />
              <GreenButton
                handleSubmit={downloadBufferSeatReport}
                title="Buffer Seat Report"
                disabled={
                  !courseid ||
                  (!!courseList?.all?.find((obj) => obj.courseid == courseid)?.ispcmb && !pcmb) ||
                  ([124, 125].includes(courseid) && !noofattempt)
                }
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} paddingTop={2}>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateCount || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Candidates"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.venues || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Venues"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.venueCount || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Venue Capacity for batch"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.bufferSeats || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Buffer Seats for batch"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.bufferSeatsUsed || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Buffer Seats Used"}
              </Typography>
            </Card>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", paddingTop: 2 }}>
          <Typography
            variant="p"
            color="#212121"
            fontWeight={600}
            sx={{ paddingBottom: 2 }}
            component="p"
          >
            Allocate Venue
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item md={12}>
            <Box>
              {/* <Select
                fullWidth
                defaultValue={0}
                size="small"
                onChange={handlePreferenceChange}
              >
                <MenuItem value={0}>Overall Preference</MenuItem>
                <MenuItem value={1}>Preference 1</MenuItem>
                <MenuItem value={2}>Preference 2</MenuItem>
                <MenuItem value={3}>Preference 3</MenuItem>
                <MenuItem value={4}>Preference 4</MenuItem>
               <MenuItem value={5}>Preference 5</MenuItem> 
              </Select> */}
              <Select
                // fullWidth
                defaultValue={0}
                size="small"
                onChange={handleLogicAppliedChange}
                value={isLogicApplied}
              >
                <MenuItem value={0}>Preference + PWD</MenuItem>
                <MenuItem value={1}>Dynamic Proportion Scheduling</MenuItem>
              </Select>
            </Box>
          </Grid>
          {/* <Grid item md={3}>
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Is Logic Applied
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={isLogicApplied}
                onChange={handleLogicAppliedChange}
                row
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid> */}
          <Grid item md={6}>
            <Grid item md={12}>
              <Typography variant="h5" fontWeight={600}>
                Gender Percentages ( Overall Should be 100%)
              </Typography>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Male
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.male}
                        variant="outlined"
                      >
                        <TextField
                          {...register("male", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              let general = parseFloat(watch("general")) || 0;

                              // trigger("female")
                              // trigger("others")
                              let overall = female + others + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            // setValue(
                            //   "male",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("male", e.target.value);
                            trigger("female");
                            trigger("others");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.male ? errors.male.message : ""}
                        />

                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.male ? errors.male.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Female
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.female}
                        variant="outlined"
                      >
                        <TextField
                          {...register("female", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let male = parseFloat(watch("male")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              let general = parseFloat(watch("general")) || 0;

                              // trigger("male")
                              // trigger("others")
                              let overall = male + others + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            // setValue(
                            //   "female",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("female", e.target.value);
                            trigger("male");
                            trigger("others");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.female ? errors.female.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.female ? errors.female.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Others
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.others}
                        variant="outlined"
                      >
                        <TextField
                          {...register("others", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let male = parseFloat(watch("male")) || 0;
                              let general = parseFloat(watch("general")) || 0;
                              // trigger("male")
                              // trigger("female")
                              let overall = female + male + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            // setValue(
                            //   "others",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("others", e.target.value);
                            trigger("male");
                            trigger("female");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.others ? errors.others.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.others ? errors.others.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    General
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.general}
                        variant="outlined"
                      >
                        <TextField
                          {...register("general", {
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let male = parseFloat(watch("male")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              // trigger("male")
                              // trigger("female")
                              let overall = female + male + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            // setValue(
                            //   "general",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("general", e.target.value);
                            trigger("male");
                            trigger("female");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.others ? errors.others.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.general ? errors.general.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {isLogicApplied != 0 && female + male + others + general != 100 && (
              <p className="" style={{ color: "red" }}>
                {"Gender percentage should be 100"}
              </p>
            )}
          </Grid>
          <Grid item md={6}>
            <Grid item md={12}>
              <Typography variant="h5" fontWeight={600}>
                Other Percentages ( Overall Should be 100%)
              </Typography>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Orphan
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.orphan}
                        variant="outlined"
                      >
                        <TextField
                          {...register("orphan", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let pwd = parseFloat(watch("pwd")) || 0;
                              let others = categories.reduce(
                                (acc, curr) => acc + parseFloat(watch(curr.id)),
                                0
                              );

                              let overall = pwd + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            // setValue(
                            //   "orphan",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("orphan", e.target.value);
                            // trigger("pwd")
                            trigger("pwd");
                            categories.forEach((cat) => {
                              trigger(cat.id);
                            });
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.male ? errors.male.message : ""}
                        />

                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.orphan ? errors.orphan.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    PWD
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.pwd}
                        variant="outlined"
                      >
                        <TextField
                          {...register("pwd", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              // let pwd = parseFloat(watch("pwd")) || 0;
                              let orphan = parseFloat(watch("orphan")) || 0;
                              let others = categories.reduce(
                                (acc, curr) => acc + parseFloat(watch(curr.id)),
                                0
                              );
                              let overall = orphan + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          // onInput={percentageValidation}
                          onChange={(e) => {
                            // setValue(
                            //   "pwd",
                            //   (parseFloat(e.target.value) || 0) * 1
                            // );
                            setValue("pwd", e.target.value);
                            // trigger("pwd")
                            trigger("orphan");
                            categories.forEach((cat) => {
                              trigger(cat.id);
                            });
                          }}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.pwd ? errors.pwd.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.pwd ? errors.pwd.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {categories?.map((item) => {
              return (
                <Grid item md={12} mb={1}>
                  <Grid container alignItems="center">
                    <Grid item md={4}>
                      <Typography variant="body1" fontWeight={600}>
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid item md={8}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 4,
                        }}
                      >
                        <Box>
                          <FormControl
                            fullWidth
                            error={!!errors[item.id]}
                            variant="outlined"
                          >
                            <TextField
                              {...register(item.id, {
                                // required: "This is a required Field *",
                                validate: (val) => {
                                  let pwd = parseFloat(watch("pwd")) || 0;
                                  let orphan = parseFloat(watch("orphan")) || 0;
                                  let others = categories
                                    .filter((cat) => cat.id !== item.id)
                                    .reduce(
                                      (acc, curr) =>
                                        acc + parseFloat(watch(curr.id)),
                                      0
                                    );
                                  let overall = pwd + orphan + others;
                                  return percentageValidation(
                                    parseFloat(val),
                                    overall
                                  );
                                },
                                disabled: parseInt(isLogicApplied) !== 1,
                              })}
                              onChange={(e) => {
                                // setValue(
                                //   item.id,
                                //   (parseFloat(e.target.value) || 0) * 1
                                // );
                                setValue(item.id, e.target.value);
                                trigger("pwd");
                                trigger("orphan");
                                categories
                                  .filter((cat) => cat.id !== item.id)
                                  .forEach((cat) => {
                                    trigger(cat.id);
                                  });
                              }}
                              // onInput={percentageValidation}
                              defaultValue={0}
                              inputProps={{
                                style: { fontWeight: 600, textAlign: "center" },
                              }}
                              // helperText={errors.male ? errors.male.message : ""}
                            />

                            <span
                              className="error"
                              style={{ color: "red", fontSize: "12px" }}
                            >
                              {errors[item.id] ? errors[item.id].message : ""}
                            </span>
                          </FormControl>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
            {parseInt(isLogicApplied) !== 0 &&
              (() => {
                const orphan = parseFloat(watch("orphan")) || 0;
                const pwd = parseFloat(watch("pwd")) || 0;
                const others = categories.reduce(
                  (acc, curr) => acc + (parseFloat(watch(curr.id)) || 0),
                  0
                );
                const total = orphan + pwd + others;

                return total < 100 ? (
                  <p style={{ color: "red" }}>
                    Overall percentage should be 100.
                  </p>
                ) : null;
              })()}
          </Grid>

          <Grid item md={12}>
            <DuplicateCandidates
              courseid={courseid}
              ispcm={ispcm}
              ispcb={ispcb}
              noofattempt={noofattempt}
            />
          </Grid>

          <Grid item md={12}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <BluePrimaryButton
                title="Run"
                // disabled={
                //   !candidateCount ||
                //   candidateCount <= 0 ||
                //   (isLogicApplied != 0 &&
                //     female + male + others + general != 100)
                // }
                disabled={
                  !candidateCount ||
                  candidateCount <= 0 ||
                  (parseInt(isLogicApplied) !== 0 &&
                    (female + male + others + general !== 100 ||
                     (parseFloat(watch("orphan")) || 0) +
                       (parseFloat(watch("pwd")) || 0) +
                       categories.reduce((acc, curr) => acc + (parseFloat(watch(curr.id)) || 0), 0) != 100))
                }
                
                handleSubmit={handleSubmit(onRunPreference, onError)}
              />
              <BluePrimaryButton
                title="Reset Data"
                handleSubmit={() => onReset(courseid, preferenceid)}
              />
              {/* <GreenButton title="Download Venue Template" /> */}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", textAlign: "center" }} paddingTop={2}>
          <CommonTable tableData={seatAllocationData} columnData={columnData} />
        </Box>
        <Grid container spacing={2} paddingTop={2}>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.allocated &&
                  candidateAllocationDetails?.allocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(candidateAllocationDetails?.allocated[0])
                      .length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.allocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.allocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "Allocated Candidate Details",
                      columns: columns,
                      content: candidateAllocationDetails?.allocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "Allocated Candidates" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.allocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Allocated Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );
                if (
                  candidateAllocationDetails?.notallocated &&
                  candidateAllocationDetails?.notallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(candidateAllocationDetails?.notallocated[0])
                      .length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.notallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.notallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "notallocated Candidate Details",
                      columns: columns,
                      content: candidateAllocationDetails?.notallocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "notallocated Candidates" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.notallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Non Allocated Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.disabilityallocated &&
                  candidateAllocationDetails?.disabilityallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    ).length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "disabilityallocated",
                      columns: columns,
                      content: candidateAllocationDetails?.disabilityallocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "disabilityallocated" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.disabilityallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Allocated Disability Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.disabilitynotallocated &&
                  candidateAllocationDetails?.disabilitynotallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    ).length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "Non Allocated Disability",
                      columns: columns,
                      content:
                        candidateAllocationDetails?.disabilitynotallocated,
                    },
                  ];
                  xlsx(
                    data,
                    {
                      ...settings,
                      fileName: "disabilitynotallocated Candidates",
                    },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.disabilitynotallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Non Allocated Disability Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                if (allCandidates.length > 0) {
                  let columns = Object.keys(allCandidates[0]).map((key) => ({
                    label: key,
                    value: key,
                  }));

                  let data = [
                    {
                      sheet: "All Candidate Details",
                      columns: columns,
                      content: allCandidates,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "All Candidates" },
                    callback
                  );
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {allCandidates.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                All Candidates
              </Typography>
            </Card>
          </Grid>
        </Grid>

        {/* <Grid container paddingTop={2} justifyContent="end">
                    <Grid item>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'end' }}>
                            <DangerButton title="Get Candidate data(API)" />
                            <DangerButton title="Browse and Upload Candidate Data" />
                            <DangerButton title="Download candidate data " />

                        </Box>
                    </Grid>
                </Grid> */}
      </Card>
      <Modal
        open={open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {file ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{file?.name}</Box>
              <Box
                onClick={() => setFile(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={ToggleOpen}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading || !file || courseid === 0}
              handleClick={handleUploadVenue}
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
      <Modal
        open={importApiConfirmOpen}
        onClose={() => setImportApiConfirmOpen(false)}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: 440,
            bgcolor: "background.paper",
            borderRadius: 5,
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          <Typography variant="h6" fontWeight={600} mb={1}>
            Get Venue Data from VBSA
          </Typography>
          <Typography mb={3}>
            This will replace all existing venues for the selected course with the venue data from VBSA. Continue?
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <CloseButton name="Cancel" handleClose={() => setImportApiConfirmOpen(false)} />
            <BluePrimaryButton title="Continue" handleSubmit={handleImportVenueFromApi} />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={!!deleteConfirm}
        onClose={() => setDeleteConfirm(null)}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: 460,
            bgcolor: "background.paper",
            borderRadius: 5,
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          <Typography variant="h6" fontWeight={600} mb={1}>
            {deleteConfirm?.kind === "reset" ? "Reset allocation?" : "Run allocation again?"}
          </Typography>
          <Typography mb={1}>
            {deleteConfirm?.kind === "reset"
              ? "This deletes the selected allocation:"
              : "This course already has an allocation. Running again deletes it and allocates everyone from scratch:"}
          </Typography>
          <Box component="ul" sx={{ mt: 0, mb: 2, pl: 3 }}>
            <li>{deleteConfirm?.impact?.allocations} allocations</li>
            <li>{deleteConfirm?.impact?.rollnumbers} roll numbers</li>
            <li>{deleteConfirm?.impact?.venuechanges} venue changes</li>
          </Box>
          <Typography mb={3}>
            {deleteConfirm?.kind === "reset"
              ? "Candidates will have no venue until allocation is run again. Continue?"
              : "Candidates may get different venues. Continue?"}
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <CloseButton name="Cancel" handleClose={() => setDeleteConfirm(null)} />
            <BluePrimaryButton
              title={deleteConfirm?.kind === "reset" ? "Reset" : "Run Again"}
              handleSubmit={() => {
                dispatch(deleteConfirm.action);
                setDeleteConfirm(null);
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Index;
